import { z } from 'zod';
import { arrayToNonEmptyArray } from './array-to-non-empty-array';
import { Bdm1Outcome } from '@prisma/client';

export const bdm1OutcomeZodEnum = () =>
  z
    .enum(arrayToNonEmptyArray(Object.values(Bdm1Outcome)))
    .transform(
      (value) => Bdm1Outcome[value as keyof typeof Bdm1Outcome] as Bdm1Outcome,
    );
